export default __webpack_public_path__ + "static/media/element_89.456d9caa.jpg";